import { render, staticRenderFns } from "./Dishes.vue?vue&type=template&id=d5db6f52&"
import script from "./Dishes.vue?vue&type=script&lang=ts&"
export * from "./Dishes.vue?vue&type=script&lang=ts&"
import style0 from "./Dishes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports